module.exports = __webpack_public_path__ + "img/hr-express-splitter-west.d60d1b18.png";